import axios from "axios"

import { PingatorResultType } from "./types"

export const getPingatorResults = async () => {
   const result = await axios.get<PingatorResultType>(
      process.env.PREACT_APP_API_URL ?? "http://localhost:3005/",
   )

   // Map backend payload/payloadSize to FE `payloadSize` (support legacy `mtu` too)
   const mapOne = (r: any) =>
      r && typeof r === "object"
         ? {
              ...r,
              payloadSize: Object.prototype.hasOwnProperty.call(r, "payloadSize")
                 ? (r as any).payloadSize
                 : Object.prototype.hasOwnProperty.call(r, "payload")
                 ? (r as any).payload
                 : (r as any).mtu ?? null,
           }
         : r

   const data = result.data as any
   if (data?.pingAddresses?.results) {
      data.pingAddresses.results = data.pingAddresses.results.map(mapOne)
   }
   if (data?.portAddresses?.results) {
      data.portAddresses.results = data.portAddresses.results.map(mapOne)
   }
   if (data?.worldAddresses?.results) {
      data.worldAddresses.results = data.worldAddresses.results.map(mapOne)
   }

   return data as PingatorResultType
}
